/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';

import RouteNames from '../../../RouteNames';
import * as selectors from '../../../redux/reduxSelectors';

import NavigationActions from '../../../redux/NavigationActions';
import { selectors as groupSelectors, actions as groupActions } from '../../../../redux/ducks/group';
import GroupMetadata from '../../../../../models/GroupMetadata';
import { TrackEvent } from '../../../../../utilities/UserMetrics';
import { userSelectors } from '../../../../redux/selectors_authorizedApp';

import Search from './Search';

function mapStateToProps(state, routerProps) {
  const history = routerProps.history;
  const profileId = selectors.getActiveProfileId(state);
  const groupIds = groupSelectors.getSearchResults(state);
  const activeGroupIds = groupSelectors.getActiveGroupIdsForProfile(state, profileId);

  return {
    results: groupIds,
    disabledResults: activeGroupIds,
    languageCode: userSelectors.getPreferredLanguageCode(state),
    isSearching: !groupSelectors.getIsSearchComplete(state),
    queryPlaceholder: 'groupsSelect.search.field.hint',
    onGoBack: () => {
      NavigationActions.goBackTo(history, RouteNames.myGroups());
    },
    onSelectResult: (groupId) => {
      const groupMetadata = new GroupMetadata(groupSelectors.getGroup(state, groupId));
      TrackEvent.groups.selected(groupMetadata.data.name);
      NavigationActions.replace(history, RouteNames.joinGroup(groupId));
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmitSearch: (query, languageCode) => {
      dispatch(groupActions.search(query, languageCode));
    },
    onCancelSearch: () => {
      dispatch(groupActions.clearSearchResults());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Search);
